import { useMemo } from "react";
import * as S from "./styles";
import { useNavigate } from "react-router-dom";
import { AuthLoginPubsResponse, authPubOwnerToken } from "../../../../api/auth";
import { LOCAL_STORAGE_PUB_ID } from "../../../../utils/network";

const SelectedPub = ({ pubOwners }: { pubOwners: AuthLoginPubsResponse[] }) => {
  const navigate = useNavigate();

  const handleClick = async (pubId: number) => {
    try {
      await authPubOwnerToken(pubId);
      localStorage.setItem(LOCAL_STORAGE_PUB_ID, String(pubId));
      navigate("/");
    } catch (e) {
      alert("관리자 로그인 정보를 확인해주세요.");
    }
  };

  const recentLoginPubId = useMemo(() => {
    const withToken = pubOwners.filter((pub) => pub.tokenCreatedAt);
    if (withToken.length === 0) return null;
    return withToken.reduce((latest, current) => {
      const latestTime = new Date(latest.tokenCreatedAt!).getTime();
      const currentTime = new Date(current.tokenCreatedAt!).getTime();
      return currentTime > latestTime ? current : latest;
    }).pubId;
  }, [pubOwners]);

  const isNearLoginPub = (item: AuthLoginPubsResponse) => {
    if (!item.tokenCreatedAt || recentLoginPubId === null) return false;
    return recentLoginPubId === item.pubId;
  };

  return (
    <S.PubListWrapper>
      <div className="title">매장을 선택해 주세요. </div>
      <S.PubListFormWrapper>
        {pubOwners.map((item) => (
          <S.PubListItemWrapper
            key={item.pubId}
            onClick={() => handleClick(item.pubId)}
          >
            <S.PubListFormContent>
              <S.PubListFormName>
                <div>{item.pubName}</div>
                {isNearLoginPub(item) && <div className="login">최근 접속</div>}
              </S.PubListFormName>
              <div className="address">{item.address}</div>
            </S.PubListFormContent>
            <img src="/image-web/login/arrow.svg" alt="arrow" />
          </S.PubListItemWrapper>
        ))}
      </S.PubListFormWrapper>
    </S.PubListWrapper>
  );
};

export default SelectedPub;
